<template>
  <Card shadow v>
    <p slot="title">
      在线人数
      <span class="card-small-title">(每小时单位)</span>
    </p>
    <div slot="extra">
      <Button class="mr-1" :loading="itemsLoading" type="info" @click="fristData">更新数据</Button>
      <DatePicker
        :value="selectDate"
        confirm
        type="daterange"
        class="home-Date-input"
        placeholder="开始日期 - 结束日期"
        :options="options"
        @on-change="change"
        @on-ok="linkonlinemem"
        :clearable="false"
        placement="bottom-end"
      ></DatePicker>
    </div>
    <Row type="flex" justify="space-around">
      <Col class="mb-1">
        <div class="home-smallCard-data default">
          <p class="home-smallCard-data-title">总在线人数</p>
          <div class="home-smallCard-data-content">
            <Icon type="md-people" />
            {{allnumber | commaFormat}}
          </div>
        </div>
      </Col>
      <Col class="mb-1" v-for="(it, index) in siteNumber" :key="index">
        <div class="home-smallCard-data" :style="{ background:  colors[index] }">
          <p class="home-smallCard-data-title">{{it.site}} 在线人数</p>
          <div class="home-smallCard-data-content">
            <Icon type="md-people" />
            {{it.data | commaFormat}}
          </div>
        </div>
      </Col>
      <Col span="24" class="mt-2">
        <v-chart autoresize :options="polar" style="height:300px;padding-top: 2px" />
      </Col>
    </Row>
  </Card>
</template>
<script>
import moment from "moment-timezone";
import echartsmixins from '../mixins/echarts'
export default {
  name: 'ChartsTimeNumber',
  mixins: [echartsmixins],
  data () {
    return {
      items: [],
      itemsTime: null,
      itemsLoading: false,
      selectDate: [],
      ApiDate: [],
      options: {
        shortcuts: [
          {
            text: '今天',
            value () {
              const end = new Date();
              return [end, end];
            }
          },
          {
            text: '昨天',
            value () {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              return [start, start];
            }
          },
          {
            text: '最近3天',
            value () {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
              return [start, end];
            }
          },
          {
            text: '最近一周',
            value () {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              return [start, end];
            }
          },
          {
            text: '最近30天',
            value () {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              return [start, end];
            }
          }
        ]
      },
      polar: {
        // title: {
        //   text: '各站点上线人数',
        //   subtext: '每小时单位',
        //   padding: 10,
        // },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          position: function (pt) {
            return [pt[0], '10%'];
          },
          formatter(params) {
            let output = `<strong>${params[0].data.time || params[0].name}</strong><br/>`
            params.forEach(item => {
              const data = item.data
              output += `
                <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background:${item.color}"></span>
                ${item.seriesName}<br/>
                在線人數：${data.value}<br/>
                會員數：${data.memcou}<br/>
                代理數：${data.amcou}<br/>
                操作員數：${data.adcou}<br/><br/>
              `
            })
            return output
          }
        },
        toolbox: {
          right: 10,
          feature: {
            dataView: {
              show: true,
              readOnly: true,
              optionToContent: function (opt) {
                let axisData = opt.xAxis[0].data; //坐标数据
                let series = opt.series; //折线图数据
                let tdHeads = '<td  style="padding: 0 10px">时间</td>'; //表头
                let tdBodys = ''; //数据
                series.forEach(function (item) {
                  //组装表头
                  tdHeads += `<td style="padding: 0 10px">${item.name}</td>`;
                });
                let table = `<table border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center"><tbody><tr>${tdHeads} </tr>`;
                for (let i = 0, l = axisData.length; i < l; i++) {
                  for (let j = 0; j < series.length; j++) {
                    //组装表数据
                    let value = typeof series[j].data[i] === 'object'
                      ? series[j].data[i].value
                      : series[j].data[i]

                    tdBodys += `<td>${value}</td>`;
                  }
                  table += `<tr><td style="padding: 0 10px">${axisData[i]}</td>${tdBodys}</tr>`;
                  tdBodys = '';
                }
                table += '</tbody></table>';
                return table;
              }
            },
            magicType: { show: true, type: ['line', 'bar'] },
            dataZoom: {
              yAxisIndex: 'none'
            },
            restore: {},
            saveAsImage: {}
          }
        },
        legend: {
          padding: 10,
          data: [],
          selected: {}
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            alignWithLabel: true
          },
          data: [],
          name: '小时',
        },
        yAxis: [
          {
            name: '人数',
            type: 'value',
            position: 'left',
            boundaryGap: [0, '100%'],
            axisLine: {
              lineStyle: {
                color: '#1d3c78'
              }
            }
          }
        ],
        dataZoom: [{
          type: 'inside',
          start: 0,
          end: 100
        }, {
          start: 0,
          end: 100,
          handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '80%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 3,
            shadowColor: 'rgba(0, 0, 0, 0.6)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          }
        }],
        series: [],
      }
    }
  },
  created () {
    this.fristData()
  },
  beforeDestor () {
    clearInterval(this.itemsTime)
  },
  computed: {
    siteNumber () {
      return this.polar.series.map(it => {
        const obj = {}
        obj.site = it.name
        obj.data = 0
        obj.data += it.data[it.data.length - 1].value
        return obj
      })
    },
    allnumber () {
      return this.siteNumber.reduce((acc, val) => acc += val.data, 0)
    }
  },
  methods: {
    fristData () {
      const today = moment().format("YYYY-MM-DD")
      this.selectDate = [today, today]
      this.ApiDate = [moment().format("YYYY-MM-DD 00:00:00"), moment().format("YYYY-MM-DD HH:mm:00")]
      this.linkonlinemem()
      // this.itemsTime = setInterval(() => this.linkonlinemem(), 1200000)
    },
    change (val) {
      const today = moment().format("YYYY-MM-DD")
      this.selectDate = val
      if (val[1] == today) {
        const todayTime = `${val[0]} 00:00:00`
        this.ApiDate = [todayTime, moment().format("YYYY-MM-DD HH:mm:00")]
      } else {
        this.ApiDate = [`${val[0]} 00:00:00`, `${val[1]} 23:00:00`]
      }
    },
    refresh () {
      this.polar.xAxis.data = []
      this.polar.series = []
      this.polar.legend.data = []
    },
    async linkonlinemem () {
      this.itemsLoading = true
      this.refresh()
      try {
        const obj = {
          siteid: '0',
          startTiem: this.ApiDate[0],
          endTiem: this.ApiDate[1]
        }
        const res = await this.$axios.linkonlinemem(obj)
        if ('status' in res && res.status === 0) return
        this.$Eventhub.$emit('setChartsMonth', res)
        let start_date = moment(obj.startTiem, "YYYY-MM-DD HH:mm:ss");
        let end_date = moment(obj.endTiem, "YYYY-MM-DD HH:mm:ss");
        let seconds = end_date.diff(start_date, "seconds");
        let hours = (seconds / 60 / 60);
        this.items = res.map((it, index) => {
          let data = []
          let x = 0
          for (let i = 0; i <= hours; i++) {
            let length = 0
            let text = moment(start_date, "YYYY-MM-DD HH:mm:ss").add(i, 'hours');
            let tiem = text.format("YYYY-MM-DD HH:mm:ss")
            if (index == 0) this.polar.xAxis.data.push(tiem)
            if ('hostline' in it.data) length = it.data.hostline.length
            do {
              if (length == x) {
                data.push(0)
                break;
              } else {
                const col = it.data.hostline[x]
                if (col.hostline == tiem) {
                  data.push({
                    value: col.onlinememcou,
                    memcou: col.memcou,
                    amcou: col.amcou,
                    adcou: col.adcou,
                    time: col.hostline,
                    name: it.memname
                  })
                  x += 1;
                  break;
                } else {
                  data.push(0)
                  break;
                }
              }
            } while (x <= length)

          }
          const series = this.seriesObject(it, index, data)
          this.polar.series.push(series)
          this.polar.legend.data.push(it.memname)
          this.polar.legend.selected[it.memname] = it.memname !== "開獎網 日"
          return it
        })
        this.timeItemsLoading()
      } catch (error) {
        console.log(error);
        this.timeItemsLoading()
      }
    },
    seriesObject (val, index, data) {
      return {
        name: val.memname,
        type: 'line',
        smooth: true,
        data: data,
        itemStyle: { color: this.colors[index] },
        markPoint: {
          data: [
            { type: 'max', name: '最大值' },
          ]
        }
      }
    },
    timeItemsLoading () {
      setTimeout(() => this.itemsLoading = false, 2000)
    }
  }
}
</script>